import { createSlice } from "@reduxjs/toolkit";
import type { NavLayout } from "../components/layout/navLayout";

const NAV_LAYOUTS: NavLayout[] = ["top", "sidebar", "professional"];

const getInitialNavLayout = (): NavLayout => {
  return "sidebar";
};

const getInitialProfessionalSidebar = () => {
  try {
    const stored = localStorage.getItem("professional-sidebar-expanded");
    if (stored === "false") return false;
    if (stored === "true") return true;
  } catch (error) {
    console.log("Unable to read professional sidebar state", error);
  }
  return true;
};

const initialState = {
  loading: false,
  class: "default-loading",
  text: "Deleting",
  device: "",
  calendarOpen: false,
  calendarOpenIndex: -1,
  listContentMinHeight: 0,
  scrollTop: 0,
  warn: false,
  loaded: false,
  navLayout: getInitialNavLayout(),
  sidebarExpanded: false,
  professionalSidebarExpanded: getInitialProfessionalSidebar(),
};

const commonplaceSlice = createSlice({
  name: "commonplace",
  initialState,
  reducers: {
    whetherSpinning(state, action) {
      state.loading = action.payload.loading;
      state.class = action.payload.class;
      state.text = action.payload.text;
    },
    setDeviceGlobally(state, action) {
      state.device = action.payload.device;
    },
    setCalendarOpenOrNot(state, action) {
      state.calendarOpen = action.payload.boo;
      if (action.payload.index !== null && action.payload.index !== undefined) {
        state.calendarOpenIndex = action.payload.index;
      }
    },
    setHeight(state, action) {
      state.listContentMinHeight = action.payload.height;
    },
    setScrollTop(state, action) {
      state.scrollTop = action.payload.distance;
    },
    setWarn(state, action) {
      state.warn = action.payload.warn;
    },
    setLoaded(state, action) {
      state.loaded = action.payload.loaded;
    },
    setNavLayout(state, action) {
      const layout = action.payload.layout as NavLayout;
      if (!NAV_LAYOUTS.includes(layout)) return;

      state.navLayout = layout;
      try {
        localStorage.setItem("nav-layout", layout);
      } catch (error) {
        console.log("Unable to save nav layout to localStorage", error);
      }
    },
    setSidebarExpanded(state, action) {
      state.sidebarExpanded = action.payload;
    },
    setProfessionalSidebarExpanded(state, action) {
      state.professionalSidebarExpanded = Boolean(action.payload);
      try {
        localStorage.setItem(
          "professional-sidebar-expanded",
          String(state.professionalSidebarExpanded),
        );
      } catch (error) {
        console.log("Unable to save professional sidebar state", error);
      }
    },
  },
});

export const {
  whetherSpinning,
  setDeviceGlobally,
  setCalendarOpenOrNot,
  setHeight,
  setScrollTop,
  setWarn,
  setLoaded,
  setNavLayout,
  setSidebarExpanded,
  setProfessionalSidebarExpanded,
} = commonplaceSlice.actions;

export default commonplaceSlice.reducer;
